import { ReportPageLayoutDeviceType } from '../clients/reporting-clients';

export const dashboardLayoutBreakpoints = {
  [ReportPageLayoutDeviceType.Desktop]: { width: 840, designerWidth: 'calc(100% - 2px)' },
  [ReportPageLayoutDeviceType.Tablet]: { width: 600, designerWidth: '840px' },
  [ReportPageLayoutDeviceType.Phone]: { width: 0, designerWidth: '600px' },
};
